import React from 'react'

const Fotter = () => {
  return (
    <div className=' bg-slate-950 text-white w-[100%] h-[8vh] text-center items-center flex justify-center'> Copyright © 2024 - Pasindu Peiris</div>
  )
}

export default Fotter